export const userTypes = Object.freeze(
  /** @type {const} */ ({
    BROKER: 'broker',
    INSURED: 'insured',
  })
);
